import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import Connector from '../baseConnector';


import './GithubConnector.css'
import CancelButton from '../../../../../components/buttons/cancel/CancelButton';
import ContinueButton from '../../../../../components/buttons/continue/ContinueButton';
import ExitButton from '../../../../../components/buttons/exit/ExitButton';

const GitHubConnector = ({ name, mode, id, exitWindow }) => {
    const [accountType, setAccountType] = useState("account")
    const [usePAT, setUsePAT] = useState(false)
    const [useApp, setUseApp] = useState(false)
    const [data, setData] = useState({
        pat: '',
        account: '',
        organization: '',
        app_id: '',
        installation_id: '',
        key_file: {},
        })

    const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // This is the base64 string
        reader.onerror = reject;
        reader.readAsDataURL(file); // Convert the file to base64
    });
    }

    const connector = new Connector(name, id, mode, exitWindow, "Github");

    const onSubmit = async (data) => {
        if (Object.keys(data.key_file).length !== 0){
            data.key_filename = data.key_file[0].name
            data.key_file = await getBase64(data.key_file[0]);
        }
        connector.handleSubmit(data);
    }

    const loadData = async() => {
        if (mode === "edit") {
        const newData = await connector.loadData(data);
        setAccountType(data.account ? "account" : "organization")
        setData(newData)
        }
    }

    useEffect(() => {loadData()} ,[])

    console.log(data)

    return (
        <form autoComplete="off" onSubmit={onSubmit} className="github-connector-form connector-form glassmorphism">
            <ExitButton onClick={(e)=>{e.preventDefault();exitWindow()}}/>
            <div className='content'>
                <div className='first-column column'>
                    <h1 className="form-title">GitHub Connector</h1>
                    <label className="form-label">
                        Select Type:
                        <select name="accountType" onChange={(e)=>setAccountType(e.target.value)} className="form-select">
                            <option selected={accountType === "account"} value="account">Account</option>
                            <option selected={accountType === "organization"}  value="organization">Organization</option>
                        </select>
                    </label>
                    {accountType === 'account' ? (
                        <label className="form-label-input">
                            Account:
                            <input autoComplete="off" value={data.account} onChange={(e)=>setData({...data, account: e.target.value})} type="text" className="form-input" />
                        </label>
                    ) : (
                        <label className="form-label-input">
                            Organization:
                            <input  autoComplete="off" value={data.organization} onChange={(e)=>setData({...data, organization: e.target.value})} type="text" className="form-input" />
                        </label>
                    )}

                    <div className='pat-container'>
                    <label className="form-label">
                        <input type="checkbox" name="usePAT" checked={usePAT} onChange={(e)=>{setUsePAT(e.target.checked)}}  className="form-checkbox" />
                        Use PAT
                    </label>
                    {usePAT && (
                        <label className="form-label">
                            PAT Token:
                            <input value={data.pat} onChange={(e)=>setData({...data, pat: e.target.value})} type="text"  className="form-input maskedInput" />
                        </label>
                    )}
                    </div>
                </div>
                <div className='second-column column'>
                <label className="form-label">
                    <input type="checkbox" name="useApp" checked={useApp} onChange={(e)=>{setUseApp(!useApp)}} className="form-checkbox" />
                    Use App
                </label>
                {useApp && (
                    <>
                        <label className="form-label-input">
                            App ID:
                            <input value={data.app_id} onChange={(e)=>setData({...data, app_id: e.target.value})} type="text" className="form-input" />
                        </label>
                        <label className="form-label-input">
                            Installation ID:
                            <input value={data.installation_id} onChange={(e)=>setData({...data, installation_id: e.target.value})} type="text"  className="form-input" />
                        </label>
                        <label className="form-label">
                            PEM File:
                            <input  type='file' onChange={(e)=>console.log(e.target.files[0])} className="form-file-input" />
                        </label>
                    </>
                )}
                </div>
            </div>
            <div className='form-buttons'>
                <ContinueButton text={mode} onClick={e=>{e.preventDefault(); onSubmit(data)}} />
            </div>
        </form>
    );
};

export default GitHubConnector;
